// @ts-nocheck
import * as React from 'react';
import { ReactComponent as HeartSvg } from '@assets/icons/favorite.svg';
import { ReactComponent as PrivacySvg } from '@assets/icons/privacy.svg';
import { ReactComponent as BellSvg } from '@assets/icons/bell.svg';
import { ReactComponent as ArrowSvg } from '@assets/icons/arrow.svg';
import { ReactComponent as FeedSvg } from '@assets/icons/feed.svg';
import { ReactComponent as MyCircleSvg } from '@assets/icons/my_circle.svg';
import { ReactComponent as ChatSvg } from '@assets/icons/chat.svg';
import { ReactComponent as ExternalLinkSvg } from '@assets/icons/external_link.svg';
import { ReactComponent as CavetSvg } from '@assets/icons/cavet.svg';
import { ReactComponent as ProfileSvg } from '@assets/icons/profile.svg';
import { ReactComponent as FlagSvg } from '@assets/icons/flag.svg';
import { ReactComponent as SettingSvg } from '@assets/icons/setting.svg';
import { ReactComponent as SquareCheckSvg } from '@assets/icons/square_check.svg';
import { ReactComponent as KarmaSvg } from '@assets/icons/karma.svg';
import { ReactComponent as WorldSvg } from '@assets/icons/world.svg';
import { ReactComponent as FilledSvg } from '@assets/icons/filled_arrow.svg';
import { ReactComponent as ShareCircleSvg } from '@assets/icons/share_circle.svg';
import { ReactComponent as PersonSvg } from '@assets/icons/person.svg';
import { ReactComponent as PeopleSvg } from '@assets/icons/people.svg';
import { ReactComponent as GroupSvg } from '@assets/icons/group.svg';
import { ReactComponent as ScheduleSvg } from '@assets/icons/schedule.svg';
import { ReactComponent as DraftSvg } from '@assets/icons/draft.svg';
import { ReactComponent as EmojiSvg } from '@assets/icons/emoji.svg';
import { ReactComponent as FileSvg } from '@assets/icons/file.svg';
import { ReactComponent as VideoSvg } from '@assets/icons/video.svg';
import { ReactComponent as PhotoSvg } from '@assets/icons/camera.svg';
import { ReactComponent as CommentSvg } from '@assets/icons/comment.svg';
import { ReactComponent as EditSvg } from '@assets/icons/edit.svg';
import { ReactComponent as TrofeuSvg } from '@assets/icons/trofeu.svg';
import { ReactComponent as RejectedSvg } from '@assets/icons/rejected.svg';
import { ReactComponent as VerifiedSvg } from '@assets/icons/verified.svg';
import { ReactComponent as PostSvg } from '@assets/icons/post.svg';
import { ReactComponent as ChallengeSvg } from '@assets/icons/challenge.svg';
import { ReactComponent as QuestionSvg } from '@assets/icons/question.svg';
import { ReactComponent as ScheduledSvg } from '@assets/icons/scheduled.svg';
import { ReactComponent as BookmarkSvg } from '@assets/icons/bookmark.svg';
import { ReactComponent as FlaggedSvg } from '@assets/icons/flagged.svg';
import { ReactComponent as Stars } from '@assets/icons/star.svg';
import { ReactComponent as Friends } from '@assets/icons/friends.svg';
import { ReactComponent as CopySvg } from '@assets/icons/copy.svg';
import { ReactComponent as EmptyPostSvg } from '@assets/icons/empty_post_icon.svg';
import { ReactComponent as PendingSvg } from '@assets/icons/pending.svg';
import { ReactComponent as GroupBadgeSvg } from '@assets/icons/group_requestor_icon.svg';
import { ReactComponent as Alert } from '@assets/icons/alert.svg';
import { ReactComponent as Warning } from '@assets/icons/warning.svg';
import { ReactComponent as Accepted } from '@assets/icons/accepted.svg';
import { ReactComponent as Discover } from '@assets/icons/discover.svg';
import { ReactComponent as Info } from '@assets/icons/info.svg';
import { ReactComponent as GroupRequest } from '@assets/icons/groupRequest.svg';
import { ReactComponent as Radio } from '@assets/icons/radio.svg';
import { ReactComponent as RadioSelected } from '@assets/icons/radio_selected.svg';
import { ReactComponent as Checkbox } from '@assets/icons/checkbox.svg';
import { ReactComponent as CheckboxSelected } from '@assets/icons/checkbox_selected.svg';
import { ReactComponent as SocialEvent } from '@assets/icons/socialEvent.svg';
import { ReactComponent as Article } from '@assets/icons/article.svg';
import { ReactComponent as Audio } from '@assets/icons/audio.svg';
import { ReactComponent as Poll } from '@assets/icons/poll.svg';
import { ReactComponent as VideoIcon } from '@assets/icons/videoIcon.svg';
import { ReactComponent as Survey } from '@assets/icons/survey.svg';
import { ReactComponent as Series } from '@assets/icons/series.svg';
import { ReactComponent as Check } from '@assets/icons/check.svg';
import { ReactComponent as Clear } from '@assets/icons/clear.svg';
import { ReactComponent as StarMark } from '@assets/icons/starmark.svg';
import { ReactComponent as Upload } from '@assets/icons/upload.svg';
import { ReactComponent as VideoContent } from '@assets/icons/videoContent.svg';
import { ReactComponent as EmptyEvent } from '@assets/icons/emptyEvent.svg';
import { ReactComponent as ArticleSvg } from '@assets/icons/content/article.svg';
import { ReactComponent as AudioSvg } from '@assets/icons/content/audio.svg';
import { ReactComponent as PollSvg } from '@assets/icons/content/poll.svg';
import { ReactComponent as SeriesSvg } from '@assets/icons/content/series.svg';
import { ReactComponent as SurveySvg } from '@assets/icons/content/survey.svg';
import { ReactComponent as Location } from '@assets/icons/location.svg';
import { ReactComponent as DisclaimerSvg } from '@assets/icons/content/disclaimer.svg';
import { ReactComponent as HideSvg } from '@assets/icons/hide.svg';
import { ReactComponent as UnhideSVG } from '@assets/icons/unhide.svg';
import { ReactComponent as DeleteSvg } from '@assets/icons/delete.svg';
import { ReactComponent as Subtract } from '@assets/icons/subtract.svg';
import { ReactComponent as NotificationsSvg } from '@assets/icons/notifications.svg';
import { ReactComponent as NotificationsOffSvg } from '@assets/icons/notifications_off.svg';
import SvgIcons from '../../../../models/constants/svgIcons';

const SVG_COMPONENTS: Record<
  SvgIcons,
  (props: React.SVGProps<SVGSVGElement>) => React.ReactNode
> = {
  [SvgIcons.HEART]: (props: React.SVGProps<SVGSVGElement>) => (
    <HeartSvg {...props} />
  ),
  [SvgIcons.BELL]: (props: React.SVGProps<SVGSVGElement>) => (
    <BellSvg {...props} />
  ),
  [SvgIcons.ARROW]: (props: React.SVGProps<SVGSVGElement>) => (
    <ArrowSvg {...props} />
  ),
  [SvgIcons.FEED]: (props: React.SVGProps<SVGSVGElement>) => (
    <FeedSvg {...props} />
  ),
  [SvgIcons.MY_CIRCLE]: (props: React.SVGProps<SVGSVGElement>) => (
    <MyCircleSvg {...props} />
  ),
  [SvgIcons.CHAT]: (props: React.SVGProps<SVGSVGElement>) => (
    <ChatSvg {...props} />
  ),
  [SvgIcons.EXTERNAL_LINK]: (props: React.SVGProps<SVGSVGElement>) => (
    <ExternalLinkSvg {...props} />
  ),
  [SvgIcons.PRIVACY]: (props: React.SVGProps<SVGSVGElement>) => (
    <PrivacySvg {...props} />
  ),
  [SvgIcons.CAVET]: (props: React.SVGProps<SVGSVGElement>) => (
    <CavetSvg {...props} />
  ),
  [SvgIcons.PROFILE]: (props: React.SVGProps<SVGSVGElement>) => (
    <ProfileSvg {...props} />
  ),
  [SvgIcons.FLAG]: (props: React.SVGProps<SVGSVGElement>) => (
    <FlagSvg {...props} />
  ),
  [SvgIcons.SETTING]: (props: React.SVGProps<SVGSVGElement>) => (
    <SettingSvg {...props} />
  ),
  [SvgIcons.SQUARE_CHECK]: (props: React.SVGProps<SVGSVGElement>) => (
    <SquareCheckSvg {...props} />
  ),
  [SvgIcons.KARMA]: (props: React.SVGProps<SVGSVGElement>) => (
    <KarmaSvg {...props} />
  ),
  [SvgIcons.PUBLIC]: (props: React.SVGProps<SVGSVGElement>) => (
    <WorldSvg {...props} />
  ),
  [SvgIcons.FILLED_ARROW]: (props: React.SVGProps<SVGSVGElement>) => (
    <FilledSvg {...props} />
  ),
  [SvgIcons.SHARE_CIRCLE]: (props: React.SVGProps<SVGSVGElement>) => (
    <ShareCircleSvg {...props} />
  ),
  [SvgIcons.PERSON]: (props: React.SVGProps<SVGSVGElement>) => (
    <PersonSvg {...props} />
  ),
  [SvgIcons.PEOPLE]: (props: React.SVGProps<SVGSVGElement>) => (
    <PeopleSvg {...props} />
  ),
  [SvgIcons.GROUP]: (props: React.SVGProps<SVGSVGElement>) => (
    <GroupSvg {...props} />
  ),
  [SvgIcons.SCHEDULE]: (props: React.SVGProps<SVGSVGElement>) => (
    <ScheduleSvg {...props} />
  ),
  [SvgIcons.DRAFT]: (props: React.SVGProps<SVGSVGElement>) => (
    <DraftSvg {...props} />
  ),
  [SvgIcons.EMOJI]: (props: React.SVGProps<SVGSVGElement>) => (
    <EmojiSvg {...props} />
  ),
  [SvgIcons.FILE]: (props: React.SVGProps<SVGSVGElement>) => (
    <FileSvg {...props} />
  ),
  [SvgIcons.VIDEO]: (props: React.SVGProps<SVGSVGElement>) => (
    <VideoSvg {...props} />
  ),
  [SvgIcons.PHOTO]: (props: React.SVGProps<SVGSVGElement>) => (
    <PhotoSvg {...props} />
  ),
  [SvgIcons.COMMENT]: (props: React.SVGProps<SVGSVGElement>) => (
    <CommentSvg {...props} />
  ),
  [SvgIcons.EDIT]: (props: React.SVGProps<SVGSVGElement>) => (
    <EditSvg {...props} />
  ),
  [SvgIcons.TROFEU]: (props: React.SVGProps<SVGSVGElement>) => (
    <TrofeuSvg {...props} />
  ),
  [SvgIcons.REJECTED]: (props: React.SVGProps<SVGSVGElement>) => (
    <RejectedSvg {...props} />
  ),
  [SvgIcons.VERIFIED]: (props: React.SVGProps<SVGSVGElement>) => (
    <VerifiedSvg {...props} />
  ),
  [SvgIcons.POST]: (props: React.SVGProps<SVGSVGElement>) => (
    <PostSvg {...props} />
  ),
  [SvgIcons.CHALLENGE]: (props: React.SVGProps<SVGSVGElement>) => (
    <ChallengeSvg {...props} />
  ),
  [SvgIcons.QUESTION]: (props: React.SVGProps<SVGSVGElement>) => (
    <QuestionSvg {...props} />
  ),
  [SvgIcons.SCHEDULED]: (props: React.SVGProps<SVGSVGElement>) => (
    <ScheduledSvg {...props} />
  ),
  [SvgIcons.BOOKMARK]: (props: React.SVGProps<SVGSVGElement>) => (
    <BookmarkSvg {...props} />
  ),
  [SvgIcons.FLAGGED]: (props: React.SVGProps<SVGSVGElement>) => (
    <FlaggedSvg {...props} />
  ),
  [SvgIcons.STARS]: (props: React.SVGProps<SVGSVGElement>) => (
    <Stars {...props} />
  ),
  [SvgIcons.FRIENDS]: (props: React.SVGProps<SVGSVGElement>) => (
    <Friends {...props} />
  ),
  [SvgIcons.COPY]: (props: React.SVGProps<SVGSVGElement>) => (
    <CopySvg {...props} />
  ),
  [SvgIcons.EMPTYPOST]: (props: React.SVGProps<SVGSVGElement>) => (
    <EmptyPostSvg {...props} />
  ),
  [SvgIcons.PENDING]: (props: React.SVGProps<SVGSVGElement>) => (
    <PendingSvg {...props} />
  ),
  [SvgIcons.GROUPBADGE]: (props: React.SVGProps<SVGSVGElement>) => (
    <GroupBadgeSvg {...props} />
  ),
  [SvgIcons.ALERT]: (props: React.SVGProps<SVGSVGElement>) => (
    <Alert {...props} />
  ),
  [SvgIcons.WARNING]: (props: React.SVGProps<SVGSVGElement>) => (
    <Warning {...props} />
  ),
  [SvgIcons.ACCEPTED]: (props: React.SVGProps<SVGSVGElement>) => (
    <Accepted {...props} />
  ),
  [SvgIcons.INFO]: (props: React.SVGProps<SVGSVGElement>) => (
    <Info {...props} />
  ),
  [SvgIcons.GROUP_REQUESt]: (props: React.SVGProps<SVGSVGElement>) => (
    <GroupRequest {...props} />
  ),
  [SvgIcons.RADIO]: (props: React.SVGProps<SVGSVGElement>) => (
    <Radio {...props} />
  ),
  [SvgIcons.RADIOSELECTED]: (props: React.SVGProps<SVGSVGElement>) => (
    <RadioSelected {...props} />
  ),
  [SvgIcons.CHECKBOX]: (props: React.SVGProps<SVGSVGElement>) => (
    <Checkbox {...props} />
  ),
  [SvgIcons.CHECKBOXSELECTED]: (props: React.SVGProps<SVGSVGElement>) => (
    <CheckboxSelected {...props} />
  ),

  [SvgIcons.SOCIAL_EVENT]: (props: React.SVGProps<SVGSVGElement>) => (
    <SocialEvent {...props} />
  ),

  [SvgIcons.ARTICLE]: (props: React.SVGProps<SVGSVGElement>) => (
    <Article {...props} />
  ),
  [SvgIcons.AUDIO]: (props: React.SVGProps<SVGSVGElement>) => (
    <Audio {...props} />
  ),
  [SvgIcons.VIDEOICON]: (props: React.SVGProps<SVGSVGElement>) => (
    <VideoIcon {...props} />
  ),
  [SvgIcons.POLL]: (props: React.SVGProps<SVGSVGElement>) => (
    <Poll {...props} />
  ),
  [SvgIcons.SURVEY]: (props: React.SVGProps<SVGSVGElement>) => (
    <Survey {...props} />
  ),
  [SvgIcons.SERIES]: (props: React.SVGProps<SVGSVGElement>) => (
    <Series {...props} />
  ),
  [SvgIcons.CHECK]: (props: React.SVGProps<SVGSVGElement>) => (
    <Check {...props} />
  ),
  [SvgIcons.CLEAR]: (props: React.SVGProps<SVGSVGElement>) => (
    <Clear {...props} />
  ),
  [SvgIcons.STARMARK]: (props: React.SVGProps<SVGSVGElement>) => (
    <StarMark {...props} />
  ),
  [SvgIcons.UPLOAD]: (props: React.SVGProps<SVGSVGElement>) => (
    <Upload {...props} />
  ),
  [SvgIcons.VIDEO_CONTENT]: (props: React.SVGProps<SVGSVGElement>) => (
    <VideoContent {...props} />
  ),
  [SvgIcons.EMPTY_EVENT]: (props: React.SVGProps<SVGSVGElement>) => (
    <EmptyEvent {...props} />
  ),
  [SvgIcons.DISCOVER]: (props: React.SVGProps<SVGSVGElement>) => (
    <Discover {...props} />
  ),
  [SvgIcons.ARTICLE]: (props: React.SVGProps<SVGSVGElement>) => (
    <ArticleSvg {...props} />
  ),
  [SvgIcons.AUDIO]: (props: React.SVGProps<SVGSVGElement>) => (
    <AudioSvg {...props} />
  ),
  [SvgIcons.POLL]: (props: React.SVGProps<SVGSVGElement>) => (
    <PollSvg {...props} />
  ),
  [SvgIcons.SERIES]: (props: React.SVGProps<SVGSVGElement>) => (
    <SeriesSvg {...props} />
  ),
  [SvgIcons.SURVEY]: (props: React.SVGProps<SVGSVGElement>) => (
    <SurveySvg {...props} />
  ),
  [SvgIcons.VIDEO_CONTENT]: (props: React.SVGProps<SVGSVGElement>) => (
    <VideoSvg {...props} />
  ),
  [SvgIcons.LOCATION]: (props: React.SVGProps<SVGSVGElement>) => (
    <Location {...props} />
  ),
  [SvgIcons.DISCLAIMER]: (props: React.SVGProps<SVGSVGElement>) => (
    <DisclaimerSvg {...props} />
  ),
  [SvgIcons.HIDE]: (props: React.SVGProps<SVGSVGElement>) => (
    <HideSvg {...props} />
  ),
  [SvgIcons.UNHIDE]: (props: React.SVGProps<SVGSVGElement>) => (
    <UnhideSVG {...props} />
  ),
  [SvgIcons.DELETE]: (props: React.SVGProps<SVGSVGElement>) => (
    <DeleteSvg {...props} />
  ),
  [SvgIcons.SUBTRACT]: (props: React.SVGProps<SVGSVGElement>) => (
    <Subtract {...props} />
  ),
  [SvgIcons.NOTIFICATIONS]: (props: React.SVGProps<SVGSVGElement>) => (
    <NotificationsSvg {...props} />
  ),
  [SvgIcons.NOTIFICATIONS_OFF]: (props: React.SVGProps<SVGSVGElement>) => (
    <NotificationsOffSvg {...props} />
  ),
};

export default SVG_COMPONENTS;
